<!--Header-->
<div class="modal-header">
  <div class="modal-title">
    <h4>
      @if (modal_type === "Add") {
        Add New FFL
      }
      @if (modal_type === "Edit") {
        Edit FFL
      }
    </h4>
  </div>
  <button type="button" class="close-btn" (click)="closeModalClick()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<!--body-->
<div class="modal-body-scroll">
  <form [formGroup]="add_edit_ffl_form" (ngSubmit)="addEditFFLClick()">
    <!-- FFL ID Row -->
    <div class="form-group d-flex align-items-start mb-3">
      <label for="ffl" class="form-label pt-2">
        <span class="text-danger me-1">*</span>FFL:
      </label>
      <div class="flex-grow-1">
        <div class="d-flex gap-3">
          <input
            type="text"
            id="ffl"
            class="form-control text-uppercase"
            formControlName="ffl"
            [placeholder]="'_-__-___-__-__-_____'"
            [dropSpecialCharacters]="false"
            mask="0-00-000-00-0A-00000"
            (input)="verifyFFL()"
          />
          <button type="button" class="btn btn-outline-info flex-shrink-0" (click)="fflParserInput.click()">
            <i class="fa-solid fa-file-invoice me-2"></i>Parse FFL
          </button>
          <input #fflParserInput type="file" accept="image/*,application/pdf" class="d-none" (change)="onFflParserFileSelected($event)" />
            @if (is_ffl_expired) {
              <div
                class="d-flex flex-column align-items-center flex-shrink-0"
                style="width: 200px"
                >
                <span class="text-danger small fw-bold mb-1"
                  >** FFL Expired **</span
                  >
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm w-100"
                    style="color: white"
                    (click)="RequestNewFFL()"
                    >
                    Request Via Email
                  </button>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Legal Name -->
        <div class="form-group d-flex align-items-center mb-3">
          <label for="legal_name" class="form-label">
            <span class="text-danger me-1">*</span>Legal Name:
          </label>
          <input
            type="text"
            id="legal_name"
            class="form-control text-uppercase flex-grow-1"
            formControlName="legal_name"
            placeholder="Enter legal name"
            />
          </div>

          <!-- Business Name -->
          <div class="form-group d-flex align-items-center mb-3">
            <label for="business_name" class="form-label">Business Name:</label>
            <input
              type="text"
              id="business_name"
              class="form-control flex-grow-1"
              formControlName="business_name"
              placeholder="Enter business name (optional)"
              />
            </div>

            <!-- Phone Number -->
            <div class="form-group d-flex align-items-center mb-3">
              <label for="phone_number" class="form-label">Phone Number:</label>
              <input
                type="text"
                id="phone_number"
                class="form-control flex-grow-1"
                formControlName="phone_number"
                placeholder="(___) ___-____"
                [dropSpecialCharacters]="false"
                mask="(000) 000-0000"
                />
              </div>

              <!-- Email -->
              <div class="form-group d-flex align-items-center mb-3">
                <label for="email" class="form-label">
                  Email:
                </label>
                <input
                  type="text"
                  id="email"
                  class="form-control flex-grow-1"
                  formControlName="email"
                  placeholder="Enter email address"
                  />
                </div>

                <!-- Expiration Date -->
                <div class="form-group d-flex align-items-center mb-3">
                  <label for="expiration_date" class="form-label">
                    <span class="text-danger me-1">*</span>Expiration Date:
                  </label>
                  <input
                    type="text"
                    id="expiration_date"
                    class="form-control flex-grow-1"
                    formControlName="expiration_date"
                    placeholder="MM/DD/YYYY"
                    />
                  </div>

                   <div class="form-group d-flex align-items-start mb-4">
                    <label for="notes" class="form-label pt-2">Notes:</label>
                    <textarea
                      id="notes"
                      class="form-control flex-grow-1"
                      formControlName="notes"
                      rows="3"
                      placeholder="Enter notes (optional)"
                    ></textarea>
                  </div>

                  <!-- Certified FFL PDF -->
                  <div class="form-group d-flex align-items-start mb-3">
                    <label class="form-label pt-2">Certified FFL:</label>
                    <div class="flex-grow-1">
                      @if (!certified_ffl_pdf_name) {
                        <label for="certified_ffl_pdf_input" class="btn modern-btn secondary-btn btn-sm mb-0" style="cursor:pointer;">
                          <i class="fa-solid fa-paperclip me-2"></i>Attach PDF
                        </label>
                        <input
                          id="certified_ffl_pdf_input"
                          type="file"
                          accept="application/pdf"
                          class="d-none"
                          (change)="onCertifiedFflFileSelected($event)"
                        />
                      } @else {
                        <div class="d-flex align-items-center gap-2">
                          <i class="fa-solid fa-file-pdf text-danger"></i>
                          <span class="text-truncate" 
                                [ngStyle]="{'cursor': selected_row?.id && !certified_ffl_pdf_file ? 'pointer' : 'default', 'text-decoration': selected_row?.id && !certified_ffl_pdf_file ? 'underline' : 'none'}"
                                (click)="viewExistingPdf()"
                                style="max-width: 300px; font-size: 0.875rem;">{{ certified_ffl_pdf_name }}</span>
                          <button type="button" class="btn btn-sm btn-outline-danger ms-auto" (click)="removeCertifiedFflPdf()">
                            <i class="fa-solid fa-xmark"></i> Remove
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </form>
              </div>

              <div class="modal-footer">
                <div class="required-indicator me-auto">
                  <span class="text-danger">*</span> <span style="margin-left: 5px;">Denotes required fields</span>
                </div>
                <button
                  type="submit"
                  class="btn modern-btn primary-btn"
                  style="min-width: 180px"
                  [disabled]="add_edit_ffl_form.invalid || !add_edit_ffl_form.dirty"
                  (click)="addEditFFLClick()"
                  >
                  @if (modal_type === "Add") {
                    Add FFL
                  }
                  @if (modal_type === "Edit") {
                    Save Changes
                  }
                </button>
                <button
                  type="button"
                  class="btn modern-btn secondary-btn"
                  (click)="closeModalClick()"
                  >
                  Cancel
                </button>
              </div>
